import RoleSettings from './RoleSettings';

export default RoleSettings;
